import React, { Component } from 'react'
import CountUp from 'react-countup';

export default class CounterNumber extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { layoutItem, workflow: { currentItem: { layoutProperties: { workflowSubmenuConfig }, layout:{containers} }, workflowData }, __form__values,customIcons } = this.props;
        const { itemProperties } = layoutItem;
        const { counterConfig, label,placeholder } = itemProperties;
        const aftercountNum = counterConfig && counterConfig.aftercountNum;
        const countNum = counterConfig &&  parseFloat(counterConfig.countNum);
        const subtext = counterConfig && counterConfig.subtext;
        const decimal = counterConfig && parseInt(counterConfig.decimal);
  
  
  return (
      <div className='countNumCard'>
        <div className="countNumDiv">
            <div className="countNum">
               <CountUp 
               end={countNum}
               duration={7}
               decimals={decimal?decimal:0}
               />
            </div>
            <div className="aftercountNum">
               {aftercountNum}
            </div>
        </div>
        <div className="subtextNum">
            {subtext}
        </div>
      </div>
    )
  }
}
